export const messages = {
  en: {
    deleteProductStock: {
      title: 'Confirm Operation',
      confirmMessage: 'Are you sure to delete this product?',
      cancelText: 'Cancel',
      confirmText: 'Confirm Delete',
      deleteSuccess: 'Product deleted successfully',
      deleteFailed: 'Failed to delete product'
    }
  },
  zh: {
    deleteProductStock: {
      title: '确认操作',
      confirmMessage: '确定删除该商品吗？',
      cancelText: '取消',
      confirmText: '确认删除',
      deleteSuccess: '商品删除成功',
      deleteFailed: '商品删除失败'
    }
  }
}